import PromotionRoute from './PromotionRoute';
export default PromotionRoute;
